import type { CSSObject } from '@emotion/react'
import { Color, Size, Spacing, Typeface } from '@opallabs/gem'
import type { StyleProps } from './types'

export const container = ({ theme }: StyleProps): CSSObject => ({
  display: 'flex',
  flexDirection: 'column',
  fontFamily: Typeface.Default,

  '@media (prefers-contrast: more)': {
    color: Color[theme].Text.Default,
  },
})

export const allocation = ({ theme }: StyleProps): CSSObject => ({
  backgroundColor:
    theme === 'dark' ? Color[theme].Surface.N200 : Color[theme].Surface.N100,
  borderRadius: Size.Rounding,
  borderStyle: 'solid',
  borderWidth: 0,
  boxSizing: 'border-box',
  paddingBlock: Spacing.S,
  paddingInline: Spacing.S,

  '@media (prefers-contrast: more)': {
    borderColor: Color[theme].Text.Default,
    borderWidth: Spacing.XS / 2,
    paddingBlock: Spacing.XS * 1.5,
    paddingInline: Spacing.XS * 1.5,
  },
})

export const momentAllocation: CSSObject = {
  marginBlockEnd: Spacing.XS,
}

export const header: CSSObject = {
  paddingInline: Spacing.S,
}
